(function DragDropUpload($, Adzuki)
{
	"use strict";

	var DragDropUpload = {};

	// properties
	DragDropUpload.rowCount                = 0;
	DragDropUpload.lastAdded               = 0;
	DragDropUpload.field_key               = 'upload_files';
	DragDropUpload.max_files               = 1;
	DragDropUpload.delete_icon_css         = Adzuki.FaIcon.getIconStyle('delete');
	DragDropUpload.view_icon_css           = Adzuki.FaIcon.getIconStyle('search');
	DragDropUpload.appended_field_css      = 'drag-appended';

	/**
	 * Set up properties that we will use throughout
	 * @param  jquery Obj $element The element that was interacted with in the view
	 */
	DragDropUpload.init = function init($element)
	{
		this.parent_container       = $element.closest('.file-upload-options');
		this.form                   = $element.closest('form');
		this.drop_zone              = this.parent_container.find('.attachment-draganddrop');
		this.dropped_list_container = this.parent_container.find('.current_attachments');
		this.dropped_count_element  = this.parent_container.find('.dropped_count');
		this.traditional_file       = this.parent_container.find('.traditional-file-picker').find('input:file');

		this.setMaxFiles(this.parent_container);
		this.setFieldKey(this.parent_container);
	};

	/**
	 * Allows files that have been ajaxed in, to be appended to the form.
	 * Example of this on Ecards. If you select a template that has associated attachments,
	 * those files should end up appended as attachments for the current Ecard
	 *
	 * @param  file  file       user file being appended to form. looking for a key of encoded_file which contains base64_encoded file contents. see ErezEcardsController.php -> getTemplate()
	 * @param  int   field_num  since multiple files can be ajaxed in, we need to key them
	 */
	DragDropUpload.appendAjaxFileToForm = function appendAjaxFileToForm(file, field_num)
	{
		var form_name            = this.form.attr('name'),
		    readable_size        = this.readableFileSize(file.size),
		    id_prefix            = form_name + "-" + this.field_key + "-" + field_num,
		    contents_key         = id_prefix + "-contents",
		    name_key             = id_prefix + "-name",
		    field_ids            = [contents_key, name_key],
		    is_image             = false,
		    append_css           = DragDropUpload.appended_field_css + '-' + DragDropUpload.field_key;

		// add new hidden field to the form for the dragged file contents
		$("<input type='hidden' class='" + append_css + "' value='" + file.encoded_file + "' />")
			.attr("name", "form_component_data[" + form_name + "][" + DragDropUpload.field_key + "][" + field_num + "][contents]")
			.attr("id", contents_key)
			.appendTo(DragDropUpload.form);

		// add new hidden field to the form for the dragged file name
		$("<input type='hidden' class='" + append_css + " name' />")
			.attr("name", "form_component_data[" + form_name + "][" + DragDropUpload.field_key + "][" + field_num + "][name]")
			.attr("id", name_key)
			.attr("data-index", field_num)
			.val(file.name)
			.appendTo(DragDropUpload.form);

		$(document).trigger('drag-drop-files-changed');

		DragDropUpload.incrementDroppedCount();

		// is the file type an image?
		is_image = DragDropUpload.isImage(file.type);

		// show file name and size to user
		DragDropUpload.displayFileDetails(
			file.name,
			file.type,
			readable_size,
			field_ids,
			is_image,
			file.encoded_file,
			'ajaxed-file'
		);
	};

	/**
	 * Append a dragged and dropped file to a form via hidden inputs
	 * @param  file     file      user file being appended to form
	 * @param  int      field_num since multiple files can be dragged and dropped per "droppable" area, we need to key them
	 */
	DragDropUpload.appendFileToForm = function appendFileToForm(file, field_num)
	{
		var reader               = new FileReader(),
		    form_name            = this.form.attr('name'),
		    readable_size        = this.readableFileSize(file.size),
		    id_prefix            = form_name + "-" + this.field_key + "-" + field_num,
		    contents_key         = id_prefix + "-contents",
		    name_key             = id_prefix + "-name",
		    field_ids            = [contents_key, name_key],
		    is_image             = false,
		    append_css           = DragDropUpload.appended_field_css + '-' + DragDropUpload.field_key;

		reader.addEventListener("load", function load() {

			// add new hidden field to the form for the dragged file contents
			$("<input type='hidden' class='" + append_css + "' value='" + reader.result + "' />")
				.attr("name", "form_component_data[" + form_name + "][" + DragDropUpload.field_key + "][" + field_num + "][contents]")
				.attr("id", contents_key)
				.appendTo(DragDropUpload.form);

			// add new hidden field to the form for the dragged file name
			$("<input type='hidden' class='" + append_css + " name' />")
				.attr("name", "form_component_data[" + form_name + "][" + DragDropUpload.field_key + "][" + field_num + "][name]")
				.attr("id", name_key)
				.attr("data-index", field_num)
				.val(file.name)
				.appendTo(DragDropUpload.form);

			$(document).trigger('drag-drop-files-changed');

			DragDropUpload.incrementDroppedCount();

			// is the file type an image?
			is_image = DragDropUpload.isImage(file.type);

			// show file name and size to user
			DragDropUpload.displayFileDetails(
				file.name,
				file.type,
				readable_size,
				field_ids,
				is_image,
				reader.result
			);
		}, false);

		if (file) {
			reader.readAsDataURL(file);
		}
	};

	/**
	 * Append multiple files to a form
	 * @param  array   files array of files to be appended to form
	 */
	DragDropUpload.appendFilesToForm = function appendFilesToForm(files, ajaxed)
	{
		var i             = 0,
		    append_css    = DragDropUpload.appended_field_css + '-' + DragDropUpload.field_key,
		    $dropped      = $('.' + append_css + '.name'),
		    highest_index = 0,
		    field_num,
		    file,
		    ajax_files = false;

		if (ajaxed === true) {
			ajax_files = true;
		}

		// find highest index for already uploaded attachments
		if ($dropped.length > 0) {
			$dropped.each(function ech( index ) {
				var file_index = parseInt($(this).data('index'));
				if (file_index > highest_index) {
					highest_index = file_index;
				}
			});

			highest_index++;
		}

		// loop thru each file
		for (i; i < files.length; i++) {
			file      = files[i];
			field_num = (i + highest_index);

			if (ajax_files === true) {
				this.appendAjaxFileToForm(file, field_num);
			} else {
				this.appendFileToForm(file, field_num);
			}
		}
	};

	/**
	 * Clear all files that have already been dropped and appended
	 */
	DragDropUpload.clearAllDropped = function clearAllDropped()
	{
		var css = this.appended_field_css + '-' + this.field_key;

		this.dropped_list_container.html('');
		this.dropped_count_element.val(0);

		// remove all file-related fields from the form that have been appended to the form via this class
		$('.' + css).remove();
	};

	/**
	 * File removed from form.  Decrement
	 */
	DragDropUpload.decrementDroppedCount = function decrementDroppedCount()
	{
		var current_count = this.getDroppedCount(),
		    new_val       = (current_count - 1);

		this.dropped_count_element.val(new_val);
	};

	/**
	 * Show file details, such as name and file size and view/delete options
	 * @param  string   file_name  the name of the user's file
	 * @param  string   size       size of file
	 * @param  array    new_fields the hidden input fields that got appended to the form (ie. file name and file base64 contents)
	 * @param  bool     image_file was the uploaded file an image?
	 */
	DragDropUpload.displayFileDetails = function displayFileDetails(
		file_name,
		file_type,
		size,
		new_fields,
		image_file,
		reader_b64,
		custom_css
	)
	{
		var self        = this,
		    css         = 'odd',
		    delete_icon = "<span class='attachment-remove' data-contents='" + new_fields[0] + "' data-name='" + new_fields[1] + "'><a href='#'><i class='" + this.delete_icon_css + "'></i></a></span>",
		    icons       = "",
		    statusbar,
		    _img;

		if ((DragDropUpload.getDroppedCount() % 2) === 0) {
			css = 'even';
		}

		if (typeof custom_css !== 'undefined') {
			css += ' ' + custom_css;
		}

		statusbar   = $("<div class='attachment-statusbar " + css + "' data-name='" + new_fields[1] + "'></div>");
		$("<div class='attachment-filename'>" + file_name + "</div>").appendTo(statusbar);
		$("<div class='attachment-filesize text-center'>" + size + "</div>").appendTo(statusbar);

		if (image_file === true) {
			icons += "<span class='attachment-view' data-contents='" + new_fields[0] + "' data-name='" + new_fields[1] + "'><a href='#'><i class='" + this.view_icon_css + "'></i></a></span>&nbsp;";
		}

		icons += delete_icon;

		$("<div class='attachment-icons text-right'>" + icons + "</div>").appendTo(statusbar);

		this.dropped_list_container.append(statusbar);

		// this is async, but do it after the append to guarantee the statusbar exists
		if (image_file === true) {
			_img        = new Image();
			_img.src    = reader_b64;
			_img.onload = function triggerImageEvent() {
				self.parent_container.trigger('adz.image-attached', {
					file_name : file_name,
					file_type : file_type,
					image     : _img,
					$statusbar: self.form.find('.attachment-statusbar[data-name="' + new_fields[1] + '"]'),
				});
			};
		}
	};

	/**
	 * User dropped files, figure out what the max file count is and figure out what to do
	 * @param  array    files array of files
	 */
	DragDropUpload.filesDropped = function filesDropped(files)
	{
		var i               = 0,
		    new_drop_count  = files.length,
		    already_dropped = this.getDroppedCount(),
		    combined_count  = already_dropped + new_drop_count,
		    error_msg       = '',
		    file_msg        = 'file',
		    difference,
		    adjusted_files;

		// only allow 1 file
		if (this.max_files === 1) {
			this.clearAllDropped();
			this.appendFileToForm(files[0], 0);

			if (files.length > 1) {
				Adzuki.StatusMessage('Error', 'Only 1 file may be uploaded for this field. We have selected the first one in the list that you attempted to upload.');
			}

		// allow multiple files, but the user is attempting to exceed the max
		} else if (combined_count > this.max_files) {
			difference  = (this.max_files - already_dropped);
			if (this.max_files > 1) {
				file_msg += 's';
			}

			error_msg   = 'A max of ' + this.max_files + ' ' + file_msg + ' may be uploaded for this field.';

			// only allow some of the files
			if (difference > 0) {
				adjusted_files = [];
				for (i; i <= (difference - 1); i++) {
					adjusted_files.push(files[i]);
				}

				this.appendFilesToForm(adjusted_files);
				error_msg += ' ' + this.allowSomeDraggedFilesError(difference);
			}
			Adzuki.StatusMessage('Error', error_msg);

		// allow multiple, and the user has not exceeded the max
		} else {
			this.appendFilesToForm(files);
		}
	};

	DragDropUpload.allowSomeDraggedFilesError = function allowSomeDraggedFilesError(difference)
	{
		var msg    = 'The first ',
		    action = 'has';

		if (difference > 1) {
			msg    += difference + ' files';
			action  = 'have';
		} else {
			msg += 'file';
		}

		msg += ' in the latest list that you attempted to upload ' + action + ' been selected.';

		return msg;
	};

	// Number of files already dropped successfully
	DragDropUpload.getDroppedCount = function getDroppedCount()
	{
		var current_val = parseInt(this.dropped_count_element.val());

		if (current_val === 'undefined') {
			return 0;
		}
		return current_val;
	};

	// Increment dropped files count
	DragDropUpload.incrementDroppedCount = function incrementDroppedCount()
	{
		var current_count = this.getDroppedCount(),
		    new_val       = (current_count + 1);

		this.dropped_count_element.val(new_val);
	};

	/**
	 * Is the file an image?
	 * @param  string    file_type file type provided by FileReader()
	 * @return boolean             true if an image
	 */
	DragDropUpload.isImage = function isImage(file_type)
	{
		var accepted_types = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];

		if ($.inArray( file_type, accepted_types) > -1) {
			return true;
		}

		return false;
	};


	/**
	 * File size in KB or MB
	 * @param  int      size  number of bytes provided by FileReader()
	 * @return string         more readable file size
	 */
	DragDropUpload.readableFileSize = function readableFileSize(size)
	{
		var sizeKB  = (size / 1024),
		    sizeStr = '',
		    sizeMB;

		if (parseInt(sizeKB) > 1024) {
			sizeMB  = (sizeKB / 1024);
			sizeStr = sizeMB.toFixed(2) + " MB";
		} else {
			sizeStr = sizeKB.toFixed(2) + " KB";
		}

		return sizeStr;
	};

	/**
	 * Remove fields that were appended to form and remove display
	 * @param  jQuery Obj $clicked_element element that was clicked to remove attachment
	 */
	DragDropUpload.removeAttachment = function removeAttachment($clicked_element)
	{
		var $row        = $clicked_element.closest('.attachment-statusbar'),
		    contents_id = $clicked_element.data('contents').replace(/\./g, '\\\.'),
			name_id     = $clicked_element.data('name').replace(/\./g, '\\\.');
		
		$(document).trigger('adz.file-removed', {
			file_name: $('#' + name_id).val()
		});
		
		// remove file-related fields from the form
		$('#' + contents_id).remove();
		$('#' + name_id).remove();

		$(document).trigger('drag-drop-files-changed');

		// remove the row of file info from the display
		$row.remove();

		// decrement the count that are pending being posted
		this.decrementDroppedCount();
	};

	/**
	 * Set field_key property based on data attribute of parent containing div
	 * @param jQuery Obj $parent_element parent div surrounding this functionality
	 */
	DragDropUpload.setFieldKey = function setFieldKey($parent_element)
	{
		var custom_key = $parent_element.data('field-key');

		if (custom_key) {
			this.field_key = custom_key;
		}
	};

	/**
	 * Set max_files property based on data attribute of parent containing div
	 * @param jQuery Obj $parent_element parent div surrounding this functionality
	 */
	DragDropUpload.setMaxFiles = function setMaxFiles($parent_element)
	{
		var max = $parent_element.data('max-files');

		if (max) {
			this.max_files = parseInt(max);
		}
	};

	/**
	 * If a file is required and the user has not uploaded one, highlight the drop zone area on desktop screens.
	 * Default validation error will highlight the normal file field on mobile screens
	 */
	DragDropUpload.toggleErrorClassDropZone = function toggleErrorClassDropZone()
	{
		this.drop_zone.toggleClass('form-error');
	};

	/**
	 * We are going to show image attachments in a modal window
	 * @param  jQuery Obj $clicked_element element that was clicked to view the file
	 * @param in_modal true if inside a modal itself already
	 */
	DragDropUpload.viewAttachment = function viewAttachment($clicked_element, in_modal)
	{
		var contents_id   = $clicked_element.data('contents'),
			name_id       = $clicked_element.data('name'),
			name          = $('#' + name_id).val(),
			contents      = $('#' + contents_id).val(),
			$image_div,
			$image,
			window_image,
			win;

		// if the attachment UI is contained within a modal, when the view is clicked show it in a new tab instead of a modal
		if (in_modal === true) {
			window_image = new Image();
			window_image.src = contents;

			win = window.open("");
			win.document.write(window_image.outerHTML);
		} else {
			if (name === undefined) {
				contents = document.getElementById(contents_id).value;
				name     = document.getElementById(name_id).value;
			}

			$image_div    = $('<div >', {
				class: 'text-center'
			});

			$image        = $('<img />', {
				src  : contents,
				style: 'max-width: 100%; max-height: 100%;'
			});

			$image.appendTo($image_div);

			$(".modal-title").text(name);
			$(".modal-body").html($image_div);
			$('#modalWindow').modal('show');
		}
	};

	DragDropUpload.start = function startUp($obj) {
		if ($obj.length > 0) {
			$obj.each(function ech( index ) {
				var $self             = $(this),
				    droppable         = $self.find('.attachment-draganddrop'),
				    normal_file_input = $self.find('.traditional-file-picker').find('input:file');

				// DragDropUpload.init($(normal_file_input));

				normal_file_input.on('change', function changeNormal(e)
				{
					var $self = $(this),
					    files = $self[0].files;

					DragDropUpload.init($self);

					if (files.length > 0) {
						DragDropUpload.filesDropped(files);
						$self.val('');
					}
				});

				normal_file_input.on('errorClassAdded', function classChange(e) {
					DragDropUpload.init($(this));
					DragDropUpload.toggleErrorClassDropZone();
				});

				droppable.on('dragenter', function drE(e)
				{
					e.stopPropagation();
					e.preventDefault();
					$(this).addClass('attachment-drag-enter');
				});

				droppable.on('dragover', function drO(e)
				{
					e.stopPropagation();
					e.preventDefault();
				});

				droppable.on('drop', function drop(e)
				{
					var files   = e.originalEvent.dataTransfer.files,
					    $self   = $(this);

					e.preventDefault();
					DragDropUpload.init($self);
					$self.removeClass('attachment-drag-enter');

					// sets properties
					DragDropUpload.filesDropped(files);
				});

				droppable.on('click', '.browse', function browse(e) {
					e.preventDefault();
					DragDropUpload.init($(this));
					DragDropUpload.traditional_file.trigger('click');
				});

			});
		}
	};

	$(document).ready(function documentReady()
	{
		if ($(".file-upload-options").length > 0) {
			DragDropUpload.start($(".file-upload-options"));

			$(document).on('click', '.file-upload-options .attachment-remove', function click(e) {
				var $self = $(this);
				e.stopPropagation();
				e.preventDefault();

				DragDropUpload.removeAttachment($self);
			});

			$(document).on('click', '.file-upload-options .attachment-view', function click(e) {
				var $self    = $(this),
					in_modal = false;
				e.stopPropagation();
				e.preventDefault();

				if ($self.parents('div.modal-body').length) {
					in_modal = true;
				}

				DragDropUpload.viewAttachment($self, in_modal);
			});
		}

	});

	Adzuki.DragDropUpload = DragDropUpload;

// close function scope and immediately execute function, passing window.Adzuki object as the argument
}(jQuery, window.Adzuki || {}));
